import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonList,
} from '@/components/common/skeleton';

export const EventsScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Tab filter placeholder */}
    <View style={styles.tabRow}>
      <SkeletonBone width={70} height={30} borderRadius={15} />
      <SkeletonBone width={80} height={30} borderRadius={15} />
      <SkeletonBone width={60} height={30} borderRadius={15} />
    </View>

    {/* Event cards */}
    <SkeletonList count={3} gap={16}>
      <SkeletonCard>
        {/* Event image placeholder */}
        <SkeletonBone width="100%" height={140} borderRadius={10} />
        {/* Event info */}
        <SkeletonBone width="75%" height={18} />
        <SkeletonBone width={120} height={14} />
        <SkeletonBone width={100} height={14} />
      </SkeletonCard>
    </SkeletonList>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 16,
  },
  tabRow: {
    flexDirection: 'row',
    gap: 8,
  },
});
